import ActionTypes from '../constants/ActionTypes';

/* Actions */

export const createChannel = (data) => ({
  type: ActionTypes.CHANNEL_CREATE,
  payload: {
    data,
  },
});

export const updateChannel = (id, data) => ({
  type: ActionTypes.CHANNEL_UPDATE,
  payload: {
    id,
    data,
  },
});

export const deleteChannel = (id) => ({
  type: ActionTypes.CHANNEL_DELETE,
  payload: {
    id,
  },
});

/* Events */

export const createChannelRequested = (data) => ({
  type: ActionTypes.CHANNEL_CREATE_REQUESTED,
  payload: {
    data,
  },
});

export const createChannelSucceeded = (channel) => ({
  type: ActionTypes.CHANNEL_CREATE_SUCCEEDED,
  payload: {
    channel,
  },
});

export const createChannelFailed = (error) => ({
  type: ActionTypes.CHANNEL_CREATE_FAILED,
  payload: {
    error,
  },
});

export const createChannelReceived = (channel) => ({
  type: ActionTypes.CHANNEL_CREATE_RECEIVED,
  payload: {
    channel,
  },
});

export const updateChannelRequested = (id, data) => ({
  type: ActionTypes.CHANNEL_UPDATE_REQUESTED,
  payload: {
    id,
    data,
  },
});

export const updateChannelSucceeded = (channel) => ({
  type: ActionTypes.CHANNEL_UPDATE_SUCCEEDED,
  payload: {
    channel,
  },
});

export const updateChannelFailed = (id, error) => ({
  type: ActionTypes.CHANNEL_UPDATE_FAILED,
  payload: {
    id,
    error,
  },
});

export const updateChannelReceived = (channel) => ({
  type: ActionTypes.CHANNEL_UPDATE_RECEIVED,
  payload: {
    channel,
  },
});

export const deleteChannelRequested = (id) => ({
  type: ActionTypes.CHANNEL_DELETE_REQUESTED,
  payload: {
    id,
  },
});

export const deleteChannelSucceeded = (channel) => ({
  type: ActionTypes.CHANNEL_DELETE_SUCCEEDED,
  payload: {
    channel,
  },
});

export const deleteChannelFailed = (id, error) => ({
  type: ActionTypes.CHANNEL_DELETE_FAILED,
  payload: {
    id,
    error,
  },
});

export const deleteChannelReceived = (channel) => ({
  type: ActionTypes.CHANNEL_DELETE_RECEIVED,
  payload: {
    channel,
  },
});
